module.exports = __webpack_public_path__ + "img/seperate-packs.42ddbba3.svg";